/* eslint-disable */
import cookies from "vue-cookies";
import util from "./util";

function identify(routes) {
  if (
    !cookies.get("identifier") &&
    util.validate(
      routes.filter((path) => {
        return window.location.pathname.toLowerCase().includes(path);
      })
    )
  )
    logout(routes);
}

function logout(routes = []) {
  cookies.remove(
    "identifier",
    "/",
    window.location.hostname === "my.atiyehiraniancf.com"
      ? ".atiyehiraniancf.com"
      : window.location.hostname
  );
  if (
    util.validate(
      routes.filter((path) => {
        return window.location.pathname.toLowerCase().includes(path);
      })
    )
  )
    window.location.href = `/Authentication?return=${encodeURIComponent(
      window.location.pathname + window.location.search
    )}`;
}

export default {
  identify,
  logout,
};
